import { render } from "./UnderConstruction.vue?vue&type=template&id=5077384a"
import script from "./UnderConstruction.vue?vue&type=script&lang=js"
export * from "./UnderConstruction.vue?vue&type=script&lang=js"

import "./UnderConstruction.vue?vue&type=style&index=0&id=5077384a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__